import { Option } from '@components/FormInput/types';
import MemoizedIcon from '@components/MemoizedIcon';
import chevronDown from '@iconify/icons-heroicons-outline/chevron-down';
import React from 'react';
import { DropdownIndicatorProps, components } from 'react-select';

const CustomDropdownIndicator = (props: DropdownIndicatorProps<Option>) => (
  <components.DropdownIndicator {...props}>
    {props.selectProps.suffix ?? (
      <MemoizedIcon
        className="flex-none text-[18px] text-black"
        icon={chevronDown}
      />
    )}
  </components.DropdownIndicator>
);

export default CustomDropdownIndicator;
